import { Box, Icon, IconButton, Typography } from '@material-ui/core'
import { ModalFullScreen } from '../ModalFullScreen'
import { useStyles } from './styles'
import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import useAction from './action'
import LinearProgressWithLabel from '../LinearProgressWithLabel'

export const ProgrammingVideo = () => {
  const styles = useStyles()
  const [playing, setPlaying] = useState(false)
  const [hasSeeked, setHasSeeked] = useState(false)
  const {
    video,
    title,
    speakers,
    percentWatched,
    handleClose,
    enabled,
    handlePosition,
    handlePlay,
    handlePause,
    handleEnded,
    videoPlayerRef,
  } = useAction()
  if (!enabled) return <></>
  const handlePlayClick = () => {
    if (!hasSeeked && videoPlayerRef.current && videoPlayerRef.current.seekTo) {
      videoPlayerRef.current.seekTo(0)
      setHasSeeked(true)
    }
    setPlaying(true)
    handlePlay()
  }
  const handlePauseClick = (e) => {
    setPlaying(false)
    handlePause(e)
  }
  const handleEndedClick = () => {
    setPlaying(false)
    handleEnded()
  }
  return (
    <ModalFullScreen>
      <Box className={styles.container}>
        <Box className={styles.videoContainer}>
          <Box className={styles.header}>
            <Typography className={styles.title}>{title}</Typography>
            <IconButton
              onClick={handleClose}
              className={styles.closeButton}>
              <Icon>cancel</Icon>
            </IconButton>
          </Box>
          <ReactPlayer
            progressInterval={5000}
            ref={videoPlayerRef}
            url={video}
            playing={playing}
            controls
            onPlay={handlePlayClick}
            onPause={handlePauseClick}
            onEnded={handleEndedClick}
            onProgress={handlePosition}
          />
          {speakers && <Typography className={styles.speakers}>{speakers}</Typography>}
          <LinearProgressWithLabel value={percentWatched} />
        </Box>
      </Box>
    </ModalFullScreen>
  )
}
